import { useRef, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Upload } from "lucide-react";

export default function FileUploadButton({ onUploaded, accept = "image/*", label = "Téléverser un fichier", testId = "file-upload" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      onUploaded(`${process.env.REACT_APP_BACKEND_URL}${data.url}`);
      toast.success("Fichier téléversé");
    } catch (err) {
      toast.error(formatApiError(err, "Le téléversement a échoué."));
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <>
      <input ref={inputRef} type="file" accept={accept} className="hidden" onChange={handleFile} data-testid={`${testId}-input`} />
      <button
        type="button"
        data-testid={testId}
        disabled={uploading}
        onClick={() => inputRef.current?.click()}
        className="inline-flex items-center gap-1.5 rounded border border-stone-300 px-3 py-2 text-xs font-bold uppercase text-stone-600 transition-colors duration-300 hover:border-stone-500 disabled:opacity-60"
      >
        <Upload className="h-3.5 w-3.5" aria-hidden="true" /> {uploading ? "Envoi en cours..." : label}
      </button>
    </>
  );
}
